<template>
  <div>

    <el-dialog title="服务范围" width="30%" :visible.sync="visible" :before-close="closeDialog" :close-on-click-modal="false" v-if="flag">
      <p>
        {{flag}}发送平台服务范围<span style="color:red">不限船司，不限港口</span>，

        如您无法找到您需要的船公司，请点击联系客服按钮，

        请客服后台添加新船公司即可
      </p>
      <span slot="footer" class="dialog-footer">
        <a href="https://wpa1.qq.com/lZNz1Cmh?_type=wpa&qidian=true">
          <el-button type="primary" size="small">联系客服</el-button>
        </a>

        <el-button @click="closeDialog" size="small" style="margin-left: 10px">关闭</el-button>

      </span>
    </el-dialog>
    <el-dialog title="服务范围" width="75%" class="abow_dialog" :before-close="closeDialog" :close-on-click-modal="false" :visible.sync="visible" v-else>

      <div style="height:600px; overflow: auto;" v-if="serviceScopeData.length">
        <p style="color: red; font-size: 18px">平台支持{{serviceScopeData.length}}家船公司和{{shippingAgentList.length}}家船代的舱单发送，清单如下：</p>
        <div class="head_title">船公司</div>
        <ul class="c_list">
          <li class="c_item" v-for="(item,index) in serviceScopeData" :key="index">
            <div class="c_logo">
              <div class="c_logo c_logo1_bg" :style="'background-position:0px '+(index*(-100))+'px'"></div>
            </div>
            <p>{{item.commonAbbreviations}}</p>
            <p>{{item.shippingCompany}}</p>
          </li>
        </ul>
        <div class="head_title">船代</div>
        <ul class="c_list">
          <li class="c_item" v-for="(item,index) in shippingAgentList" :key="index">
            <div class="c_logo c_logo2_bg" :style="'background-position: 0 '+(index*(-100))+'px'"></div>
            <p>{{item.shippingAgent}}</p>
            <p>船代</p>
          </li>
        </ul>
        <div class="head_title">备注</div>
        <div>
          <div>
            <p class="c_remark_name">上海中联（船代）</p>不支持TSL/TSC（德翔）船公司的舱单发送
          </div>
          <div>
            <p class="c_remark_name">正利（船司）</p>“CNC—正利”的台湾线，船司代码请选择“CST—宝华”
          </div>
          <div>
            <p class="c_remark_name">长荣（船司）</p>不支持上海中联代理的船舶（UNI-ACTIVE/KUO CHANG/UNI-ADROIT/HE YANG/JJ SUN）
          </div>
          <div>
            <p class="c_remark_name">新东（船司）</p>“NOS—新东”的韩国仁川线，船司代码请选择“NSI—宁波远洋”
          </div>
          <div>
            <p class="c_remark_name">新加坡海运（船司）</p>边航船公司子品牌，SEC开头的提单号可以发，船公司请选“SCO—新加坡海运”
          </div>
          <div>
            <p class="c_remark_name">德翔（船司）</p>不支持上海中联船代代理的航线
          </div>
        </div>
        <!-- <el-table :data="serviceScopeData">
          <el-table-column property="commonAbbreviations" label="常见缩写" min-width="120" align="left"></el-table-column>
          <el-table-column property="shippingCompany" label="船公司" min-width="150" align="left"></el-table-column>
          <el-table-column property="commonShippingAgents" label="常见船代" min-width="300" align="left"></el-table-column>
          <el-table-column property="remark" label="备注" min-width="400" align="left"></el-table-column>
        </el-table> -->
      </div>
      <div style="height:600px; overflow: auto;" v-else>
        <p style="color: red; font-size: 18px">平台支持{{shanghaiPortList.length}}家上海口岸和{{foreignPortList.length}}家外口岸的VGM发送，清单如下：</p>
        <div class="head_title">上海口岸支持接收方</div>
        <ul class="c_list">
          <li class="c_item" v-for="(item,index) in shanghaiPortList" :key="index">
            <div class="c_logo c_logo3_bg" :style="'background-position:0px '+(index*(-100))+'px'"></div>
            <p>{{item.shanghaiPort.split('—')[0]}}</p>
            <p>{{item.shanghaiPort.split('—')[1]}}</p>
          </li>
        </ul>
        <div class="head_title">外口岸支持接收方</div>
        <ul class="c_list">
          <li class="c_item" v-for="(item,index) in foreignPortList" :key="index">
            <div class="c_logo c_logo4_bg" :style="'background-position:0px '+(index*(-100))+'px'"></div>
            <p>{{item.foreignPort.split('—')[0]}}</p>
            <p>{{item.foreignPort.split('—')[1]}}</p>
          </li>
        </ul>
        <!-- <el-table :data="list">
          <el-table-column property="shanghaiPort" label="上海口岸支持接收方" min-width="260"></el-table-column>
          <el-table-column property="foreignPort" label="外口岸支持接收方" min-width="260"></el-table-column>
        </el-table> -->
      </div>

    </el-dialog>
  </div>

</template>

<script>
import { shippingAgentList, foreignPortList, shanghaiPortList } from './scopecode'

export default {
  name: 'ServiceScope',
  props: {
    flag: String,
    visible: Boolean,
    serviceScopeData: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      shippingAgentList: [],
      shanghaiPortList: [],
      foreignPortList: [],
    }
  },
  created () {
    this.shippingAgentList = shippingAgentList
    this.foreignPortList = foreignPortList
    this.shanghaiPortList = shanghaiPortList
  },
  methods: {
    // 关闭
    closeDialog () {
      this.$emit('closeDialog')
    },

  }
}
</script>

<style lang="less" scoped>
// @import './cps_style.less';
p {
  margin: 0;
}
.head_title {
  margin: 20px 0;
  font-weight: 600;
}
.head_title::before {
  content: '';
  display: inline-block;
  background: #5572fd;
  height: 22px;
  width: 5px;
  margin-right: 10px;
  position: relative;
  top: 6px;
}
.c_list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  list-style: none;
  margin-bottom: 20px !important;
}
.c_list .c_item {
  height: 146px;
  width: 122px;
  text-align: center;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  box-shadow: 4px 4px 10px -4px #ccc;
}
.c_list .c_item p {
  font-size: 16px !important;
  line-height: 18px;
}
.c_list .c_item .c_logo {
  height: 100px;
  width: 120px;
  border-radius: 5px;
}
.c_remark_name {
  display: inline-block;
  width: 140px;
  text-align: right;
  margin-right: 30px;
}
.c_logo1_bg {
  background: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/cps_2.0/carrier.png)
    no-repeat;
}
.c_logo2_bg {
  background: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/thumbnail/logos_chuandai.png)
    no-repeat;
}
.c_logo3_bg {
  background: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/thumbnail/logos_shanghai.png)
    no-repeat;
}
.c_logo4_bg {
  background: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/thumbnail/logos_wai.png)
    no-repeat;
}
</style>